module.exports = {"330305001":"北岙街道","330305002":"灵昆街道","330305003":"东屏街道","330305004":"元觉街道","330305005":"霓屿街道","330305006":"昆鹏街道","330305101":"大门镇","330305202":"鹿西乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330305.json
// module id = 1072
// module chunks = 0